<template>
<!--  <ValidationObserver :ref="eleId" v-slot="{ validate, reset }">-->
<!--      <ValidationProvider :name="field.label" :rules="field.rules" v-slot="{ errors }">-->
        <div>
          <v-textarea
            v-if="field.controlType === 'v-textarea'"
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            hide-details="auto"
          ></v-textarea>
          <arb-date-picker-menu
            v-else-if="field.controlType === 'v-date-picker'"
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            :allowed="field.allowed"
            :holiday="holiday"
            hide-details="auto"
          ></arb-date-picker-menu>
          <v-select
            v-else-if="field.controlType === 'v-select'"
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            :items="items"
            :item-text="field.itemText"
            :item-value="field.itemValue"
            @change="changeEventHandler"
            hide-details="auto"
          ></v-select>
          <v-radio-group
            v-else-if="field.controlType === 'v-radio-group'"
            :label="field.label"
            v-model="current"
            hide-details="auto"
            row
          >
            <v-radio
              v-for="(option, index) in field.options[field.fieldKey]"
              color="primary"
              :key="index"
              :label="option.text"
              :value="option.value"
              :disabled="disabled"
            ></v-radio>
          </v-radio-group>
          <v-switch
            v-else-if="field.controlType === 'v-switch'"
            color="primary"
            :label="field.label"
            v-model="current"
            :true-value="field.trueValue"
            :false-value="field.falseValue"
            :disabled="disabled"
            hide-details="auto"
          ></v-switch>
          <v-text-field
            v-else-if="tool.isNotEmpty(field.mask)"
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            v-mask="field.mask"
            hide-details="auto"
          ></v-text-field>
          <v-text-field
            v-else-if="tool.isNotEmpty(field.inputType) && field.inputType === 'number'"
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            hide-details="auto"
            type="number"
          ></v-text-field>
          <v-text-field
            v-else
            :label="field.label"
            v-model="current"
            :disabled="disabled"
            hide-details="auto"
          ></v-text-field>
        </div>
<!--      </ValidationProvider>-->
<!--  </ValidationObserver>-->
</template>
<script>
// import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Tool } from '@/util'
const tool = new Tool()
export default {
  name: 'arb-validate-input',
  components: {
    // ValidationProvider,
    // ValidationObserver
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    field: {
      type: Object
    },
    items: {
      type: Array,
      default: () => []
    },
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: [Boolean, String],
      default: false
    },
    holiday: Array
  },
  data () {
    return {
      current: this.value,
      tool: tool
    }
  },
  computed: {
    eleId () {
      return `arb-validate-input_${this._uid}`
    }
  },
  watch: {
    value (val) {
      this.current = val
    },
    current (val) {
      this.$emit('input', val)
    },
    disabled (val) {
      console.log(val)
    },
    items (val) {
      console.log(val)
    }
  },
  methods: {
    changeEventHandler () {
      this.$emit('change')
    }
  }
}
</script>
